import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {EnergyMapService} from './services/energy.map.service';
import {Observable} from 'rxjs';
import {map, startWith } from 'rxjs/operators';

@Component({
    selector: 'app-energy-map-address',
    templateUrl: './energy.map.address.component.html',
    standalone: false
})
export class EnergyMapAddressComponent implements OnInit {
  /**
   * The form group with all controls
   * @protected
   */
  form: UntypedFormGroup;

  /**
   * The next step were we should navigate with the next button to.
   */
  nextStep: string = null;

  /**
   * error text key
   */
  error: string = null;

  /**
   * Placeholders for error text
   */
  errorPlaceholders: any = {};

  streetControl: UntypedFormControl;
  streetOptions: string[] = [];
  filteredOptions: Observable<string[]>;

  ngOnInit() {
    const params = {
      postalcode: this.energyMapService.getPostleitzahl(this.data.anfrage, this.data.advisorName)
    };
    this.energyMapService.streets(params).subscribe(streets => {
      this.streetOptions = streets;
      this.filteredOptions = this.streetControl.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value || '')),
      );
    });
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.streetOptions.filter(option => option.toLowerCase().includes(filterValue));
  }

  /**
   * constructor
   * @param data
   * @param dialogRef
   * @param energyMapService
   */
  constructor(@Inject(MAT_DIALOG_DATA) public data: {
    textkeyPrefix: string, lastStep: string, nextStep: string, anfrage: any, advisorName: string
              },
              private dialogRef: MatDialogRef<EnergyMapAddressComponent>, protected energyMapService: EnergyMapService) {
    // init the form
    this.streetControl = new UntypedFormControl('', [Validators.required]);
    this.form = new UntypedFormGroup({
        'energy-map-street': this.streetControl,
        'energy-map-house_number': new UntypedFormControl('', [Validators.required])
    });
  }

  /**
   * click on search button
   */
  submitSearch(): void {
    this.error = null;
    if (this.form.valid === false) {
      if (this.form.get('energy-map-street').valid === false) {
        this.error = 'street';
      }
      else if (this.form.get('energy-map-house_number').valid === false) {
        this.error = 'house_number';
      }
      return;
    }

    const data = {
      postalcode: this.energyMapService.getPostleitzahl(this.data.anfrage, this.data.advisorName),
      street: this.form.get('energy-map-street').value,
      house_number: this.form.get('energy-map-house_number').value
    };

    this.energyMapService.search(data).subscribe(response => {
      if (response.length > 0 && response[0]?.address?.postcode === data.postalcode.toString()) {
        this.error = null;
        const iframe = document.getElementById('iframe_gebaeudeauswahl') as HTMLIFrameElement;
        iframe.contentWindow.postMessage(response, '*');
        this.dialogRef.close();
      }
      else {
        this.error = 'address_not_found';
        this.errorPlaceholders = {address: data.street + ' ' + data.house_number + ' ' + data.postalcode + ' Berlin'};
      }
    });
  }
}
